import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import LawProjectTrackingWidget from '../../../widgets/admin/manage/LawProjectTrackingWidget'
import { getManageLawProjectTracking } from '../../../redux/actions/adminManageLawProjectTracking'

export default function ManageLawProjectTracking() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const request = {
        projectCode: null,
        projectName: null,
        pageNumber: 1,
        pageSize: 5,
      }

      const _schema = await getManageLawProjectTracking(request)
      console.log('getManageLawProjectTracking ', _schema)
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isManagement>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <LawProjectTrackingWidget schema={schema} />
    </SidebarProposal>
  )
}
